export const INCOME_FACTOR = 10000;

export const OceanProximity = Object.freeze({
  LESS_THAN_HOUR: "lessThanHour",
  INLAND: "inland",
  ISLAND: "island",
  NEAR_BAY: "nearBay",
  NEAR_OCEAN: "nearOcean"
});

export const Stats = Object.freeze({
  longitude: {
    mean: -119.57583393895324,
    std: 2.0018602443854547
  },
  latitude: {
    mean: 35.63957727713184,
    std: 2.1380575446331753
  },
  housingMedianAge: {
    mean: 28.6531007751938,
    std: 12.574725974901003
  },
  totalRooms: {
    mean: 2622.7283187984494,
    std: 2138.4584192430398
  },
  totalBedrooms: {
    mean: 534.9738901797725,
    std: 412.69904106103536
  },
  population: {
    mean: 1419.7908187984497,
    std: 1115.6862406181137
  },
  households: {
    mean: 497.06038032945736,
    std: 375.7208452055105
  },
  medianIncome: {
    mean: 3.8755893653100983,
    std: 1.9049495984468043
  },
  roomsPerHousehold: {
    mean: 5.4403405264058895,
    std: 2.6117118136335082,
  },
  populationPerHousehold: {
    mean: 3.0964373824861813,
    std: 11.584825942269669
  },
  bedroomsPerRoom: {
    mean: 0.21287796917099294,
    std: 0.05737925003136537
  }
});

export const standardScore = (feature, stats) => (feature - stats.mean) / stats.std;
